import { BadgeGroup, BadgeGroupItem, Inline } from '@crossnokaye/ux-common';

import { alarmTableViews } from './constants';
import { AlarmTableView, AlarmTableViewMeta } from './types';

type EquipmentDetailsAlarmTableBadgesProps = {
  tableView: AlarmTableView;
  setTableView: (tableView: AlarmTableView) => void;
  unacknowledgedCount: number;
  acknowledgedCount: number;
};

export const EquipmentDetailsAlarmTableBadges = ({
  tableView,
  unacknowledgedCount,
  acknowledgedCount,
  setTableView,
}: EquipmentDetailsAlarmTableBadgesProps) => {
  return (
    <Inline gap="sm" className={'min-w-0 flex-1 justify-end'} wrap={false}>
      <BadgeGroup
        scrollable
        selectedIds={[tableView]}
        onSelectionChange={(items) =>
          setTableView((items[0]?.id as AlarmTableView) ?? 'unacknowledged-alarms')
        }
      >
        {alarmTableViews.map((view: AlarmTableViewMeta) => (
          <BadgeGroupItem key={view.id} id={view.id} data={view}>
            {view.name} (
            {view.id === 'unacknowledged-alarms' ? unacknowledgedCount : acknowledgedCount})
          </BadgeGroupItem>
        ))}
      </BadgeGroup>
    </Inline>
  );
};
